<template>
  <div class="" v-if="wantsPickup">
    <slot><p><strong>{$t('vue.manufaktur.amag.pickupAddressAmag.collectionAddress')}}</strong></p></slot>

    <p style="font-size: 1rem!important; line-height: 1.3">
      {{ pickupLocation.name }}<br>
      {{ pickupLocation.street }} {{ pickupLocation.house_number }}<br>
      {{ pickupLocation.postal_code }} {{ pickupLocation.city }}<br>
      {{$t('vue.manufaktur.amag.pickupAddressAmag.' + vehicle.address.country)}}
    </p>
  </div>
</template>

<script>
export default {
  name: "PickupAddress",
  props: {
    vehicle: {
      type: Object,
      required: true
    },
    subscription: {
      type: Object,
      required: true
    },
    pickupLocation: {
      type: Object,
      required: true
    }
  },
  computed: {
    country () {
      switch (this.pickupLocation.country) {
        case "germany":
          return "Deutschland"
        case "switzerland":
          return "Schweiz"
      }
    },
    deliveryAddressObject () {
      if (this.subscription.delivery_address !== null) {
        return this.subscription.delivery_address;
      } else {
        if (typeof this.subscription.details.deliveryAddress !== 'undefined') {
          return this.subscription.details.deliveryAddress;
        } else {
          return this.subscription.details.address;
        }
      }
    },
    wantsPickup () {
      if (this.subscription.details !== null) {
        return this.subscription.details.deliveryMethod === 'pickup';
      }
      return false;
    }

  }
}
</script>

<style scoped>

</style>
